<h2 mat-dialog-title class="modal-headerTitle" translate>
    District Message
</h2>
<mat-dialog-content role="main">
    <div *ngFor="let districtMessage of districtMessages" id="districtMessageInfo">
        <div>
            <b>{{districtMessage.Title}}</b>
            <span [attr.aria-label]="districtMessage.RevisedDate.toDateString()"
                style="margin-left:10px;padding:5px;background-color:#ffff99;"
                *ngIf="districtMessage.RevisedDate && districtMessage.RevisedDate.toDateString() != junkDate.toDateString()">
                <span translate>Revised</span> {{districtMessage.RevisedDate|date:'MM/dd/yy'}}
            </span>
        </div>
        <p *ngIf="districtMessage.Description"
            [attr.aria-label]="stripHTML(districtMessage.Description)"
            [innerHTML]="districtMessage.Description"></p>
    </div>
</mat-dialog-content>
<mat-dialog-actions style="position: sticky">
    <div class="flex-footer-left">
    </div>
    <div class="flex-footer-right">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="dialogBox.close()"></tyl-button>
    </div>
</mat-dialog-actions>
